import React, { useState } from 'react'
import TextInputField from 'components/Form/TextInputField'
import ModalWrapper from 'components/ModalWrapper'
import { lang } from 'utils/helpers'
import './styles.scss'
import { InputControls } from 'components/common'
import { apiInchat } from 'api'

const ModalCreateChannel = ({ handleOpenCreate, isOpenCreate }) => {
  const [inputName, setInputName] = useState('')
  const [description, setDescription] = useState('')
  const [messageError, setMessageError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [channelPrivate, setChannelPrivate] = useState(true)

  const handleCreateChannel = () => {
    setMessageError('')
    if (!inputName) {
      setMessageError(lang('dashboard_add-name-channel'))
      return
    }
    setIsLoading(true)
    let data = {
      type: 'channel',
      name: inputName,
      private: channelPrivate
    }
    if(description) data = { ...data, description }
    apiInchat.createConversation(data)
      .then(() => {
        openCreate()
      })
      .catch(() => {
        setMessageError(lang('dashboard_channel-not-created'))
      })
      .finally(()=> setIsLoading(false))
  }

  const clearAll = () => {
    setInputName('')
    setDescription('')
    setMessageError('')
    setChannelPrivate(true)
  }

  const openCreate = () => {
    handleOpenCreate()
    if(isOpenCreate) clearAll()
  }

  return (
    <ModalWrapper
      isOpen={isOpenCreate}
      toggle={openCreate}
      header={lang('dashboard_create-channel')}
      body={
        <div className='inchat-create-channel-container'>
          <TextInputField
            label={lang('dashboard_channel-name')}
            classNameWrapper='text-channel-name'
            name={'name_channel'}
            value={inputName}
            onChange={setInputName}
          />
          <div className='inchat-create-channel-container__text-area'>
            <div>
              <label className='text-input-label'>{lang('dashboard_description')}</label>
              <span className='inchat-create-channel-container__text-area--optional'>{` (${lang('dashboard_optional')})`}</span>
            </div>
            <textarea
              id={'description'}
              name={'description_channel'}
              value={description}
              onChange={({ target }) => setDescription(target.value)}
              maxLength={1500}
            />
          </div>
          <InputControls
            className='switch-filter'
            injectType='external'
            label={lang('dashboard_channel-private')}
            value={channelPrivate}
            onChange={setChannelPrivate}
          />
        </div>
      }
      error={messageError}
      eventBtnTxt={lang('dashboard_create')}
      eventBtn={handleCreateChannel}
      cancelBtnTxt={lang('buttons_cancel')}
      cancelBtn={openCreate}
      isSubmitting={isLoading}
    />
  )
}

export default ModalCreateChannel